<template>
  <div>

    <div class="select-bar">
      <div class="select-box">
        <template v-for="(item, index) in selectTimeList">
          <div class="select-item-selected" v-if="selectIndex == index" :key="'s' + index">
            {{ item }}
          </div>
          <div class="select-item" v-else :key="index" @click="changeSelect(index)">
            {{ item }}
          </div>
        </template>
      </div>
    </div>

    <div>
      <el-table :data="tableData" border style="width: 100%" :header-cell-style="tableHeaderStyle">
        <el-table-column fixed prop="subjectName" label="报告期" width="160"></el-table-column>
        <el-table-column v-for="(item, index) in tableHeadData" :key="index" :prop="'data' + index" :label="item"
          width="157"></el-table-column>
      </el-table>
    </div>

  </div>
</template>
    
<script>
import { linkName, sendRequestCompany2 } from '../../../../static/js/util';

export default {
  props: [
    'comCode'
  ],
  data() {
    return {
      dataList: {},
      tableHeadData: [],
      tableData: [],

      selectTimeList: [
        '最新',
        '一季报',
        '中报',
        '三季报',
        '年报',
      ],
      selectIndex: 0
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    //表头样式
    tableHeaderStyle() {
      var style = {
        background: '#E4E7ED',
        color: '#606266',
        border: '1px solid #DCDFE6'
      }
      return style;
    },
    getData() {
      let url = '/report/reportFinance/' + this.comCode + '/7';
      // var loadmsg = this.$message('加载中');
      sendRequestCompany2(url, 'get', null, res => {
        if (res.data.code == 0 && res.data.data.resultJson != undefined && res.data.data.resultJson.length > 0) {
          // loadmsg.close();
          // this.$message({
          //     showClose: true,
          //     message: '加载完成',
          //     type: 'success',
          //     duration: 1000
          // });

          var resultJson = res.data.data.resultJson;
          this.dataList = JSON.parse(resultJson);

          this.changeSelect(0);

        } else {
          // loadmsg.close();
          this.$message({
            showClose: true,
            message: '暂无数据',
            type: 'warning'
          });
        }
      }, error => {
        // loadmsg.close();
        this.$message({
          showClose: true,
          message: '加载出错',
          type: 'error'
        });
        console.log(error);
      })
    },
    changeSelect(index) {
      this.selectIndex = index;

      if (this.dataList == null || this.dataList == undefined || this.dataList.financeReportInfos == undefined) {
        return;
      }

      if (index == 0) {

        //表头
        this.tableHeadData = [];

        this.tableData = [];
        //第一列
        for (var i = 0; i < this.dataList.financeReportSubjectNames.length; i++) {
          var row = {
            "subjectName": this.dataList.financeReportSubjectNames[i].subjectName
          }
          this.tableData.push(row);
        }

        //后续列
        for (var i = 0; i < this.dataList.financeReportInfos.length; i++) {
          var colTemp = this.dataList.financeReportInfos[i];
          this.tableHeadData.push(colTemp.reportDate);

          for (var j = 0; j < this.tableData.length; j++) {
            this.tableData[j]['data' + i] = colTemp.financeReportInfoEleList[j].subjectVal;
          }
        }

      } else if (index != 0) {

        //表头
        this.tableHeadData = [];

        this.tableData = [];
        //第一列
        for (var i = 0; i < this.dataList.financeReportSubjectNames.length; i++) {
          var row = {
            "subjectName": this.dataList.financeReportSubjectNames[i].subjectName
          }
          this.tableData.push(row);
        }

        var dateType;
        switch (index) {
          case 1: dateType = '1'; break;
          case 2: dateType = '2'; break;
          case 3: dateType = '3'; break;
          case 4: dateType = '0'; break;
        }

        //后续列
        var sign = 0;
        for (var i = 0; i < this.dataList.financeReportInfos.length; i++) {
          var colTemp = this.dataList.financeReportInfos[i];
          if (colTemp.dateType != dateType) {
            continue;
          }

          this.tableHeadData.push(colTemp.reportDate);

          for (var j = 0; j < this.tableData.length; j++) {
            this.tableData[j]['data' + sign] = colTemp.financeReportInfoEleList[j].subjectVal;
          }

          sign++;
        }
      }
    }
  }
};
</script>
    
<style scoped>
.select-bar {
  padding: 5px;
}

.select-box {
  border: 1px solid #999;
  border-radius: 5px;
  display: flex;
}

.select-item {
  color: #333;
  flex: 1;
  text-align: center;
  padding: 5px 0;
  cursor: pointer;
}

.select-item-selected {
  color: #fff;
  background-color: #DA0519;
  border-radius: 4px;
  flex: 1;
  text-align: center;
  padding: 5px 0;
}
</style>